/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const SearchIcon = createIcon(
  '0 0 20 20',
  <path
    fillRule="evenodd"
    d="M8.833 2a6.833 6.833 0 1 0 4.493 11.983 1.95 1.95 0 0 0 .289 2.393L16.239 19 19 16.239l-2.624-2.624a1.95 1.95 0 0 0-2.393-.29A6.833 6.833 0 0 0 8.833 2m-4.88 6.833a4.881 4.881 0 1 1 9.761 0 4.881 4.881 0 0 1-9.762 0"
    clipRule="evenodd"
  />,
);
